import { useEffect, useState } from 'react';
import { BezorgmomentResponse } from '../services/deliverer/types';
import { delivererClient } from '../services/deliverer/DelivererClient';

interface State {
  readonly bezorgmomenten: BezorgmomentResponse[];
  readonly error: boolean;
  readonly loading: boolean;
}

const initialState: State = {
  bezorgmomenten: [],
  error: false,
  loading: true
};

export const useBezorgmomenten = (
  postalCode: string,
  customerNumber: string | undefined,
  endDate: Date | undefined
) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (!postalCode || !customerNumber || !endDate) {
      return;
    }

    delivererClient
      .getBezorgmomentenPagedResponse(postalCode, customerNumber, endDate)
      .then((response) => {
        const now = new Date();
        const bezorgmomenten = response.items
          .filter((moment) => new Date(moment.closingTime) > now)
          .sort((a, b) => {
            const aDate = new Date(a.startDeliveryMoment ?? '').getTime();
            const bDate = new Date(b.startDeliveryMoment ?? '').getTime();
            return aDate - bDate;
          });
        setState({ bezorgmomenten, loading: false, error: false });
      })
      .catch(() => {
        setState({ bezorgmomenten: [], loading: false, error: true });
      });
  }, [postalCode, customerNumber, endDate]);

  return state;
};
